module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "login-container boxed-login",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.signin($event)
      }
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4 col-sm-4 col-sm-offset-4"
  }, [_c('div', {
    staticClass: "login-form-container"
  }, [_c('div', {
    staticClass: "j-forms",
    attrs: {
      "id": "forms-login",
      "novalidate": "novalidate"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h3', [_vm._v("密碼重設")]), _vm._v(" "), _c('div', {
    staticClass: "login-form-content"
  }, [_c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "text",
      "readonly": "",
      "id": "login",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])]), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "password",
      "placeholder": "新密碼"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_c('div', {
    staticClass: "input login-input"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.re_password),
      expression: "re_password"
    }],
    staticClass: "form-control login-frm-input",
    attrs: {
      "type": "password",
      "id": "re_password",
      "name": "re_password",
      "placeholder": "請再次輸入新密碼"
    },
    domProps: {
      "value": (_vm.re_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.re_password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "response"
  }, [_vm._v(_vm._s(_vm.response))])]), _vm._v(" "), _c('div', {
    staticClass: "login-form-footer",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('button', {
    staticClass: "btn-block btn btn-info",
    on: {
      "click": _vm.reset_validate
    }
  }, [_vm._v("送出重設")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pointer"
  }, [_c('a', {
    staticClass: "gary",
    on: {
      "click": function($event) {
        _vm.goToLogin()
      }
    }
  }, [_vm._v("返回登入頁")])])])])]), _vm._v(" "), _c('footer', {
    staticClass: "login-page-footer"
  })]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form-header"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "logo-pic",
    attrs: {
      "src": require("../../assets/img/logo3.png"),
      "alt": "logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "login"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-account"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "password"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-key"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "icon-left",
    attrs: {
      "for": "password"
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-key"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23ff5207","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/ResetPassword.vue
// module id = 676
// module chunks = 4